<template>
  <page-edicion>
    <page-header title="Crear duración de contrato" back-to="/duracionesContrato" />
    <formulario :duracion-contrato="duracionContrato" @submit="insertar" />
  </page-edicion>
</template>

<script>
import Formulario from "./Formulario.vue";
import * as duracionesContratoApi from "@/services/duracionesContrato.js";

export default {
  components: { Formulario },
  data() {
    return {
      duracionContrato: duracionesContratoApi.crear(),
    };
  },
  methods: {
    insertar() {
      duracionesContratoApi.insertar(this.duracionContrato).then(() => {
        this.$messages.success("Se ha creado el de duración de contrato");
        this.$router.push({ path: "/duracionesContrato" });
      });
    },
  },
};
</script>
